/**
 * Created by daniel.merkle on 06.09.2016.
 */
jQuery(document).ready(function($) {
    $('.ns-lead').each(function(){
        if($(this).html().trim() == ''){
            $(this).addClass('hide');
        }
    })
});